import React from "react";
import LanguageSelector from "common/LanguageSelector";
import CandidatePageWrapper from "candidate/CandidatePageWrapper";
import ProfileIconButton from "employee/ProfileIconButton";

function HubPageWrapper({
    hideProfileButton = false,
    children,
}: {
    // The Hub page is publicly accessible until the user authenticates, and
    // ProfileIconButton's `me { isHubAuth }` query errors with "Hire not found"
    // when there's no hire on the session. Pages that gate access upstream
    // (everything else that uses this wrapper) leave this false.
    hideProfileButton?: boolean;
    children: React.ReactNode;
}) {
    return (
        <CandidatePageWrapper contentClassName="hub">
            {children}
            <LanguageSelector />
            {!hideProfileButton && <ProfileIconButton />}
        </CandidatePageWrapper>
    );
}

export default HubPageWrapper;
